import * as React from 'react';
import Bottom from "./Bottom";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import MainHomeTop from "../components/main/MainHomeTop";
import MainMedical from "../components/main/MainMedical";
import MainCheck from "../components/main/MainCheck";
import MainChart from "../components/main/MainChart";
import MainCare from "../components/main/MainCare";
import MainOffice from "../components/main/MainOffice";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Divider } from "@mui/material";

import Notice from "../pages/Notice/Notice";
import { Link, useNavigate } from "react-router-dom";
import api from "../../src/utils/api_v2";
import LodingData from "../../src/utils/LodingData";

import "../App.css";
import { Accordion, AccordionDetails, AccordionSummary, Stack, Typography } from '@mui/material';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Chatbot from './Chatbot';
import $ from 'jquery';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import {useEffect, useState} from "react";
import DownloadIcon from '@mui/icons-material/Download';

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '100%',
  maxHeight: '100%',
});

const Home = () => {
  const navigate = useNavigate();

  const [noticeList, setNoticeList] = React.useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [dialogContent, setDialogContent] = useState<JSX.Element | null>(null);

  const closePopup = () => {
    setIsVisible(false);
  };

  const hideForADay = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    localStorage.setItem("hidePopupUntil", String(tomorrow.getTime()));
    setIsVisible(false);
  };
  
  React.useEffect(() => {
    // 스크립트가 이미 로드되어 있는지 확인
    // if (document.querySelector('script[src="https://www.closer.ai/js/webchat.min.js"]')) return;
    const token: any = window.localStorage.getItem("token");
    const userId: any = localStorage.getItem('userID');

    const script = document.createElement('script');
    if (userId == null || userId == '' || token == '' || token == null) {

    } else {
      script.src = 'https://www.closer.ai/js/webchat.min.js';
      script.id = 'chatbot-script';
      script.dataset.botId = 'B1j0vo';
      script.dataset.name = 'test_user_NAME';
      script.dataset.userId = 'test_user_ID';
      script.dataset.email = 'test_user_email@TESTADDRESS.GG';
      script.async = true;
      getNotcieList(); // 공지사항 리스트
      
      /* 로그인이 되어있고, api 호출 true 일때만 팝업 출력 */
      LodingData(() => api.post('customer/api/v1/popup', { familyId: localStorage.getItem('ownerFamID') })
      .then(res => {
        const isSpecial = res.data.data.isSpecial;
        const companyId = res.data.data.companyId;
        const companyList: string[] =  ['CO#68'];

        //회사별 다이얼로그
        const companyDialogs: Record<string, JSX.Element> = {
          'CO#68': (
              <>
                <p>건강검진 예약 기간은</p>
                <p>2025년 8월 8일 금요일 오후 5시까지입니다.</p>
                <p>마감일 이후 예약은 불가합니다.</p>
                <p>꼭 일정 확인 부탁드리며,</p>
                <p>개인정보( 연락처, 주소 등 ) 확인 부탁드립니다</p>
                <p></p>
                <p>감사합니다.</p>
              </>
          ),
        }
        if(isSpecial || (companyId && companyList.includes(companyId))){
          if (isSpecial) {
            setDialogContent(
                <>
                  <p>{localStorage.getItem('userName')} 님은 {new Date().getFullYear()} 년도 특수 검진 대상자입니다.</p>
                  <p>선택항목에서 반드시 특수검진을 “YES(네)”로 선택해 주십시오.</p>
                </>
            );
          } else if (companyId && companyDialogs[companyId]) {
            setDialogContent(companyDialogs[companyId]);
          }
          
          // 팝업 표시
          const hideUntil = localStorage.getItem("hidePopupUntil");
          if (!hideUntil || new Date().getTime() > Number(hideUntil)) {
            setIsVisible(true);
          }
        }
      })
      .catch(err => {
        console.log(err);
      }))
    }

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
      $('.closer_webchat_chat_wrapper').remove();
      $('.closer_webchat_hidden').remove();
      $('.closer_webchat_button_wrapper').remove();
    };
  }, [])

  const getNotcieList = () => {
    LodingData(() => api.post('customer/api/v1/CU_001_001', { cusId: localStorage.getItem('userCusID') })
      .then(res => {
        setNoticeList(res.data);
      })
      .catch(err => {
        console.log(err);
      }))
  }

  // 다운로드 클릭 시
  const handleFileDownload = (noticeId: any, fileName: any) => {
    LodingData(() => api.post('customer/api/v1/CU_007_003', { id: noticeId }, {
      responseType: 'arraybuffer',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        const type = res.headers['content-type'];
        const blob = new Blob([res.data], { type: type });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      })
      .catch(err => {
        console.log(err);
      }))
  }

  return (
    <Container sx={{ p: 0, }} className='container'>
      {/* <MainHomeTop/> */}
      <Grid item container sx={{}}>
        <MainMedical />
        <Dialog open={isVisible} onClose={closePopup}>
          <DialogTitle>안내</DialogTitle>
          <DialogContent>
            {dialogContent}
          </DialogContent>
          <DialogActions>
            <Button onClick={hideForADay} color="secondary">
              하루 동안 열지 않기
            </Button>
            <Button onClick={closePopup} color="primary">
              닫기
            </Button>
          </DialogActions>
        </Dialog>

        <Box sx={{
          width: '100%', mt: 7,
          '& .MuiContainer-root': { ml: '0 !important', maxWidth: '100% !important', pr: 0 },
          '& .topImg': { display: 'none' },
          '& .notice_display > div ': { display: 'none' },
          '& .notice_display > div:nth-of-type(1),& .notice_display > div:nth-of-type(2), & .notice_display > div:nth-of-type(3), .notice_display > div:nth-of-type(4), .notice_display > div:nth-of-type(5) ': { display: 'block !important' },
          '& .notice_display > div:nth-of-type(5)': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, },

        }}>
          <Typography sx={{ fontSize: 20, fontWeight: 700, mb: 2, width: '78%', mr: 'auto', ml: 'auto', pl: 6 }}>
            공지사항

            <Typography component={'span'} sx={{ float: 'right', cursor: 'pointer', mr: 1 }}
              onClick={() => {
                navigate('/notice/notice', { state: { supportId: 0 } });
              }}>전체보기  <KeyboardArrowRightIcon sx={{ verticalAlign: 'top', color: '#333' }} />
            </Typography>
          </Typography>

          <Box sx={noticeBox} className='notice_display'>

            {noticeList.map((item: any, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Stack direction={'column'} >
                    <Stack>
                      <Typography sx={noticeTitle}>{item.title}</Typography>
                    </Stack>
                    <Stack>
                      <Typography sx={noticeDate}><CalendarMonthIcon sx={dateIcon} />{item.createDate}</Typography>
                    </Stack>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Box className='display_flex alignitem_center'>
                    <Typography sx={noticeDownload}>첨부파일 : </Typography>
                    {
                      item.fileName == null
                        ? <Typography sx={{ fontSize: 14, color: '#999' }}>첨부파일이 없습니다.</Typography>
                        : <>
                          <Typography sx={{ fontSize: 12}}>{item.fileName}</Typography>
                          <Button className="btn_download" variant="contained" size="small" sx={{width: '60px', height: '24px', p: '0px !important'}} onClick={() => handleFileDownload(item.id, item.fileName)}>
                            <DownloadIcon sx={{fontSize: 12, m: '0px !important'}}/>
                            <Typography component="span" fontSize={9}>다운로드</Typography>
                          </Button>
                        </>
                    }
                  </Box>
                  <Divider sx={{ mb: 2, mt: 0.5 }} />
                  <Typography sx={noticeDetail}>
                    {item.content}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
        {/* <Box sx={{ width: '100%', p: 0, pr: 0 }}>
          <MainOffice />
        </Box> */}
      </Grid>

      <Bottom />

    </Container>
  );
}

const noticeBox = {
  mb: 4, maxWidth: '100%', width: '80%', mr: 'auto', ml: 'auto',
  boxSizing: 'border-box',
  '& .MuiAccordion-root:first-of-type': { borderTopLeftRadius: 20, borderTopRightRadius: 20, },
  '& .MuiAccordion-root:last-of-type': { borderBottomLeftRadius: 20, borderBottomRightRadius: 20, },
}

const noticeTitle = {
  fontSize: 16,
  fontWeight: 700,
  color: '#555',
  mb: 1,
  pr: 2,
  /*  overflow: 'hidden',
   textOverflow: 'ellipsis',
   display: '-webkit-box',
   '-webkitLineClamp': '2',
   '-webkitBoxOrient': 'vertical' */
}

const noticeDate = {
  fontSize: 13,
  color: '#777'
}

const noticeDownload = {
  fontSize: 12,
  color: '#777',
  mr: 0.5
}

const dateIcon = {
  fontSize: 16,
  color: '#888',
  verticalAlign: 'sub',
  mr: '5px'
}

const noticeDetail = {
  fontSize: 16,
  color: '#555',
  whiteSpace: 'pre-wrap'
}

export default Home;